module.exports = __webpack_public_path__ + "img/Isotipo black.1481fe49.svg";